export const getCanSubmitOffering = (data, validation) => {
  const hasNoValidationErrors = Object.values(validation).filter((x) => !!x).length === 0;
  const hasRequiredFields = !!data.dossierType && !!data.title;
  return hasRequiredFields && hasNoValidationErrors;
};
